import { axios } from '@/utils/request'

const api = {
    getGroupList: '/5cc6d5f82ea19',
    getGroupUserList: '/5cc40b408d592',
    getApplyGroupList: '/5d4d2bdbc2b45',
    saveApplyGroup: '/5d4d2a6c67d72',
    getApplyGroup: '/5d4d3a3050c29',
    deleteApplyGroup: '/5d4d2f14269f0',
    getGroupUserInfo: '/5d4e517471b3e',
    addGroupUser: '/5d6377d15dd9b'
}

export default {
    // 获取群组列表
    getGroupList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getGroupList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取群组成员
    getGroupUserList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getGroupUserList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取返利群组列表
    getApplyGroupList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getApplyGroupList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 新增返利群组
    saveApplyGroup: (params) => {
        const parameter = params
        return axios({
            url: api.saveApplyGroup,
            method: 'post',
            data: parameter
        })
    },
    // 获取返利群组
    getApplyGroup: ({ sub_id, group_wx_id}) => {
        const parameter = {
            sub_id,
            group_wx_id
        }
        return axios({
            url: api.getApplyGroup,
            method: 'get',
            params: parameter
        })
    },
    // 新增返利群组
    deleteApplyGroup: (params) => {
        const parameter = params
        return axios({
            url: api.deleteApplyGroup,
            method: 'post',
            data: parameter
        })
    },
    // 获取群成员会员信息
    getGroupUserInfo: ({ sub_id, wx_id, nickname, avatar}) => {
        const parameter = {
            sub_id,
            wx_id,
            nickname,
            avatar
        }
        return axios({
            url: api.getGroupUserInfo,
            method: 'post',
            data: parameter
        })
    },
    // 新增群成员
    addGroupUser: (params) => {
        const parameter = params
        return axios({
            url: api.addGroupUser,
            method: 'post',
            data: parameter
        })
    }
}
